import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Divider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core';

import WhatsappSrc from '../../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../../assets/img/whatsapp.png';
import SharedDialog from '../../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../../config/app';
import { ANSWER } from '../../../../../constants/website.constant';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useEndorsementsDataContext } from '../../../../../context/endorsements/endorsements.provider';
import { useVehiclesContext } from '../../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';

const EndorsementsSummary = () => {
  const [openErrors, setOpenErrors] = useState(false);
  const [element, setElement] = useState<any>('default');

  const {
    endorsement_body,
    createEndorsement,
    nextStep,
    success,
    errors,
    loading,
    cleanEndorsementBody,
  } = useEndorsementsDataContext();
  const { vehicle } = useVehiclesContext();
  const { user } = useAuthDataContext();
  const history = useHistory();

  useEffect(() => {
    if (success?.endorsement && success?.endorsement?.http_code === 200) {
      nextStep();
    } else {
      if (success?.endorsements && success?.endorsements.http_code) {
        let modalCases = {
          businessLogicErrorAfinnity:
            success?.endorsements.http_code === 406 &&
            success?.endorsement.code === 101 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company !==
              'sura',

          businessLogicErrorCompanyProducer:
            success?.endorsement.http_code === 406 &&
            success?.endorsement.code === 101 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company ===
              'sura',

          RC_afinnity:
            success?.endorsement.http_code === 409 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company !==
              'sura',

          RC_Company_Producer:
            success?.endorsement.http_code === 409 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company ===
              'sura',

          retryModal:
            success?.endorsement.http_code === 400 &&
            success?.endorsement.code === 110,
        };

        setElement(getContent(modalCases));
        setOpenErrors(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, nextStep]);

  useEffect(() => {
    if (errors.endorsement) {
      dataLayerPush('modificar_poliza_error', user?.id);
      // setOpen(true);
      if (errors?.endorsement && errors?.endorsement.http_code) {
        let modalCases = {
          businessLogicErrorAfinnity:
            errors?.endorsement.http_code === 406 &&
            errors?.endorsement.code === 101 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company !==
              'sura',

          businessLogicErrorCompanyProducer:
            errors?.endorsement.http_code === 406 &&
            errors?.endorsement.code === 101 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company ===
              'sura',

          RC_afinnity:
            errors?.endorsement.http_code === 409 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company !==
              'sura',

          RC_Company_Producer:
            errors?.endorsement.http_code === 409 &&
            endorsement_body.policyInfo[0]?.provider?.grouped_company ===
              'sura',

          retryModal:
            errors?.endorsement.http_code === 400 &&
            errors?.endorsement.code === 110,
        };

        setElement(getContent(modalCases));
        setOpenErrors(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  const handleContinue = () => {
    redirectHome();
    cleanEndorsementBody();
  };

  // Modal Content
  const getContent = (modalCasesInfo) => {
    if (modalCasesInfo.businessLogicErrorAfinnity) {
      //case afinnity
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            Por favor comunicate con nosotros por Whatsapp de Lunes a Viernes de
            9 a 18 Hs., para procesar el cambio.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.businessLogicErrorCompanyProducer) {
      // companyProducer
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            ¡Lo sentimos! El cambio no puede procesarse. Por favor comunicate
            con tu productor / asesor para procesar el cambio.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.retryModal) {
      // GW no responde
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            ¡Lo sentimos! El cambio no puede procesarse. Te pedimos que
            reintentes en otro momento.
          </Typography>
        </Box>
      );
    } else {
      // GW no responde default
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            ¡Lo sentimos! El cambio no puede procesarse. Te pedimos que
            reintentes en otro momento.
          </Typography>
        </Box>
      );
    }
  };

  // Modal Actions
  const getActions = () => {
    //affinity o RC_affinity van con whatsapp
    return (
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Box m={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleContinue}
            >
              Entendido
            </Button>
          </Box>
        </Grid>
        {ANSWER && (
          <Grid item xs={12} sm={12}>
            <Box m={2}>
              <Link
                href={appConfig?.WHATSAPP_LINK}
                rel="noopener"
                target="_blank"
              >
                <Button variant="outlined" fullWidth color="secondary">
                  <Box m={1}>
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px', marginRight: '15px' }}
                    />
                  </Box>
                  <Typography display="inline">
                    Comunicarme vía Whatsapp
                  </Typography>
                </Button>
              </Link>
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  const submitEndorsement = () => {
    if (!!endorsement_body.sumInsuredData) {
      createEndorsement(
        vehicle.id,
        vehicle.policy.id,
        vehicle.license_plate,
        'sumInsured',
        endorsement_body.sumInsuredData.jobNumber
      );
    }
    // else if (!endorsement_body.adjusment_clause) {
    //   createEndorsement(
    //     vehicle.id,
    //     vehicle.policy.id,
    //     vehicle.license_plate,
    //     'adjusment_clause',
    //     endorsement_body.sumInsuredData.jobNumber
    //   );
    // }
    else {
      createEndorsement(vehicle.id, vehicle.policy.id, vehicle.license_plate);
    }
  };

  return (
    <>
      <SharedDialog
        open={openErrors}
        onClose={() => setOpenErrors(false)}
        content={<Box>{element}</Box>}
        actions={getActions()}
      ></SharedDialog>
      <Grid
        container
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Box my={3}>
              <Typography
                variant="h6"
                style={{ marginTop: '45px', lineHeight: '28px' }}
              >
                ¿Estás seguro de los cambios a solicitar en tu póliza?
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Divider
              style={{
                marginTop: '5px',
                marginBottom: '20px',
                backgroundColor: '#FA6400',
              }}
            ></Divider>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h4"> Detalle de los cambios </Typography>
              </Grid>

              {(endorsement_body?.license_plate ||
                endorsement_body?.engine_number ||
                endorsement_body?.chassis_number ||
                endorsement_body?.gw_digital_email) && (
                <Grid item xs={12} sm={6}>
                  <Box my={2} mr={2}>
                    <Typography variant="subtitle2">
                      {' '}
                      Modificación de datos{' '}
                    </Typography>
                  </Box>
                </Grid>
              )}

              {endorsement_body?.license_plate && (
                <Grid item xs={12} sm={6}>
                  <Box my={2} mr={2}>
                    <Typography component="span" variant="subtitle1">
                      {' '}
                      Patente:{' '}
                    </Typography>
                    <Typography component="span" variant="subtitle2">
                      {' '}
                      {endorsement_body?.license_plate}{' '}
                    </Typography>
                  </Box>
                </Grid>
              )}

              {endorsement_body?.engine_number && (
                <Grid item xs={12} sm={6}>
                  <Box my={2} mr={2}>
                    <Typography component="span" variant="subtitle1">
                      {' '}
                      N° de motor:{' '}
                    </Typography>
                    <Typography component="span" variant="subtitle2">
                      {' '}
                      {endorsement_body?.engine_number}{' '}
                    </Typography>
                  </Box>
                </Grid>
              )}

              {endorsement_body?.chassis_number && (
                <Grid item xs={12} sm={6}>
                  <Box my={2} mr={2}>
                    <Typography component="span" variant="subtitle1">
                      {' '}
                      N° de chasis:{' '}
                    </Typography>
                    <Typography component="span" variant="subtitle2">
                      {' '}
                      {endorsement_body?.chassis_number}{' '}
                    </Typography>
                  </Box>
                </Grid>
              )}

              {endorsement_body?.gw_digital_email && (
                <Grid item xs={12}>
                  <Box my={2} mr={2}>
                    <Typography component="span" variant="subtitle1">
                      {' '}
                      Póliza digital:{' '}
                    </Typography>
                    <Typography component="span" variant="subtitle2">
                      {' '}
                      {endorsement_body.gw_digital_email}{' '}
                    </Typography>
                  </Box>
                </Grid>
              )}

              {/* Clausula de ajuste */}

              {/* {endorsement_body?.adjusment_clause?.data?.cost[0]?.total && (
                <Grid item xs={12}>
                  <Box my={2} mr={2}>
                    <Typography variant="h6">Clausula de ajuste</Typography>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    my={2}
                    mr={2}
                  >
                    <Box display="flex" flexWrap="wrap" my={2} mr={2}>
                      <Box m={1}>
                        <Typography
                          component="span"
                          display="block"
                          variant="subtitle2"
                        >
                          Nueva clausula de ajuste:
                        </Typography>
                      </Box>
                      <Box m={1}>
                        <Typography
                          style={{ fontWeight: "bold" }}
                          component="span"
                          variant="subtitle2"
                        >
                          $
                          {endorsement_body?.adjusment_clause?.percentage.value}
                        </Typography>
                      </Box>
                    </Box>

                    <Box my={2} mr={2}>
                      <Typography
                        style={{ fontWeight: "bold" }}
                        display="block"
                        component="span"
                        variant="subtitle2"
                      >
                        {endorsement_body?.adjustment_clause.data?.plan?.name}
                      </Typography>
                      <Typography
                        style={{ fontWeight: "bold" }}
                        component="span"
                        variant="subtitle2"
                      >
                        $
                        {
                          endorsement_body?.adjustment_clause.data?.cost[0]
                            ?.total
                        }
                      </Typography>
                    </Box>
                  </Box>

                  <Grid item xs={12}>
                    <Divider
                      style={{
                        marginTop: "20px",
                        backgroundColor: "#0033A0",
                      }}
                    ></Divider>

                    <Box
                      display="flex"
                      justifyContent="space-between"
                      my={0}
                      mr={2}
                    >
                      <Box my={1}>
                        <Typography variant="h6" color="primary">
                          Total
                        </Typography>
                      </Box>
                      <Box my={1}>
                        <Typography variant="h6" color="primary">
                          $
                          {
                            endorsement_body?.adjusment_clause.data?.cost[0]
                              ?.total
                          }
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              )} */}

              {/* Suma asegurada */}

              {endorsement_body?.sumInsuredData?.finalQuotation?.data?.cost[0]
                ?.total && (
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    my={2}
                    mr={2}
                  >
                    <Box display="flex" flexWrap="wrap" my={0} mr={2}>
                      <Box m={1}>
                        <Typography
                          component="span"
                          display="block"
                          variant="subtitle2"
                        >
                          Nueva suma asegurada:
                        </Typography>
                      </Box>
                      <Box m={1}>
                        <Typography
                          style={{ fontWeight: 'bold' }}
                          component="span"
                          variant="subtitle2"
                        >
                          ${endorsement_body?.sumInsuredData?.totalsum}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>

        {/* Total */}

        <Grid container style={{ bottom: '0px' }}>
          <Grid item xs={12}>
            <Divider
              style={{
                marginTop: '5px',
                marginBottom: '20px',
                backgroundColor: '#FA6400',
              }}
            ></Divider>
          </Grid>
          {endorsement_body?.endorsement_type === 'sumInsured' && (
            <Box>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  my={2}
                  mr={2}
                >
                  <Box my={1}>
                    <Typography variant="h6" color="primary">
                      {' '}
                      Total{' '}
                    </Typography>
                  </Box>
                  <Box my={1}>
                    <Typography variant="h6" color="primary">
                      $
                      {
                        endorsement_body?.sumInsuredData?.finalQuotation?.data
                          ?.cost[0]?.total
                      }
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <Typography
                    component="span"
                    display="block"
                    variant="subtitle2"
                  >
                    A partir de la próxima factura
                  </Typography>
                </Box>
              </Grid>
            </Box>
          )}
          <Grid item xs={12}>
            <Box>
              <Typography component="span" display="block" variant="subtitle2">
                {' '}
                A partir de la próxima factura{' '}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Box
              display="flex"
              justifyContent="center"
              style={{
                gap: '20px',
                marginTop: '30px',
                marginBottom: '25px',
              }}
            >
              <Button
                onClick={submitEndorsement}
                variant="outlined"
                color="primary"
              >
                Descartar cambios
              </Button>
              <Button
                onClick={submitEndorsement}
                variant="contained"
                color="primary"
                disabled={loading}
              >
                Solicitar cambios
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EndorsementsSummary;
